export default __webpack_public_path__ + "static/media/how-it-works-platform-channels.84760072.mp4";